import { render, staticRenderFns } from "./Unsubscribed.vue?vue&type=template&id=3bf5fcfc&scoped=true&"
import script from "./Unsubscribed.vue?vue&type=script&lang=js&"
export * from "./Unsubscribed.vue?vue&type=script&lang=js&"
import style0 from "./Unsubscribed.vue?vue&type=style&index=0&id=3bf5fcfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf5fcfc",
  null
  
)

export default component.exports